import { TRESPONSE_LEARNING_CURVE_DETAILS, TLearningCurveDTO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableInfo, TTableRowNode, TTableCellTree } from '../../table.type';

export const LEARNING_CURVES_TABLE_MODEL = {
  createModel: (
    dayCount: TRESPONSE_LEARNING_CURVE_DETAILS['day_count'],
    items: TRESPONSE_LEARNING_CURVE_DETAILS['learning_curves'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        //padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
          stickyType: 'LEFT',
        },
        edit: {
          hasAddRow: true,
          stickyType: 'RIGHT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'NAMES',
            stickyType: 'LEFT',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TLearningCurveDTO) => value.name,
                placeholder: 'Enter name',
              },
              metadata: {
                keyName: 'name',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
            stickyType: 'LEFT',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TLearningCurveDTO) => value.id,
              },
              metadata: {
                keyName: 'id',
              },
            },
          },
          ...LEARNING_CURVES_TABLE_MODEL.getHeaderConfigForDays(dayCount),
        ],
      },
      (item): TTableRowNode<TLearningCurveDTO> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.id || '',
            },
            ...LEARNING_CURVES_TABLE_MODEL.getRowCellsForDays(dayCount, item),
          ],
        };
      },
    );
  },

  getHeaderConfigForDays: (dayCount: TRESPONSE_LEARNING_CURVE_DETAILS['day_count']) => {
    const acc: TTableInfo['header']['cells'] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: 'Day' + (i + 1),
        liftedInput: {
          input: {
            type: 'INPUT',
            subType: 'number',
            setValue: (value: TLearningCurveDTO) => {
              return value.efficiencies.find((eff) => eff.day === i + 1)?.efficiency;
            },
            placeholder: 'Enter percent',
            min: 1,
          },
          metadata: {
            keyName: 'Day' + (i + 1),
          },
        },
      } as TTableInfo['header']['cells'][number]);
    }
    return acc;
  },

  getRowCellsForDays: (dayCount: TRESPONSE_LEARNING_CURVE_DETAILS['day_count'], item: TLearningCurveDTO) => {
    const acc: TTableCellTree[] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: item.efficiencies.find((eff) => eff.day === i + 1)?.efficiency || 0,
      });
    }
    return acc;
  },
};
